import {
  Button,
  FormCheckbox,
  FormField,
  FormInput,
  FormLayout,
  FormSelect,
  FormTextarea,
  WContainer,
} from 'react-components/atoms'

import { CONTATTI } from 'utils/endpoint'
import { Form, Formik } from 'formik'
import { useRouter } from 'next/router'
import { RECAPTCHA_KEY, api } from 'utils'
import React, { useEffect, useRef, useState } from 'react'
import {
  fields,
  getFormFieldStatus,
  optionsRuolo,
  schemaContatti,
} from 'components/forms-utils/utils'
import { useTrans } from 'hooks'
import ReCAPTCHA from 'react-google-recaptcha'
import { useSelector } from 'react-redux'
import { sendGTMData } from 'utils/gtm.js'

const ContattiTemplate = props => {
  const formRef = useRef()
  let recaptchaRef = useRef(null)
  const t = useTrans()

  const router = useRouter()

  const { utente } = useSelector(state => state.utente)

  const [initialValues, setInitialValues] = useState(fields)

  useEffect(() => {
    if (utente) {
      let ruolo = optionsRuolo.find(o => o.label === 'Altro')
      if (utente.ruolo) ruolo = optionsRuolo.find(o => o.label === utente.ruolo) || ruolo

      setInitialValues({
        ruolo,
        nome: utente.nome,
        cognome: utente.cognome,
        email: utente.email,
        privacy: false,
        commerciale: false,
        profilazione: false,
        richiesta: '',
      })
    }
  }, [utente])

  const postData = async data => {
    const token = await recaptchaRef.current.executeAsync() //reCAPTCHA

    if (token) {
      api.post(CONTATTI, { data }).then(response => {
        const created = response.data['created']
        if (created) {
          sendGTMData({
            event: 'GAevent',
            eventID: '13',
            eventCategory: 'form',
            eventAction: 'contatto_generale',
            eventLabel: 'richiesta_info',
          })
          router.push('/contatti/success')
        }
      })
    }
  }

  return (
    <main className="contatti-template">
      <WContainer>
        <div className="contatti-template__container">
          <div className="contatti-template__container__left">
            <div className="contatti-template__faq-mobile">
              <h3 className="contatti-template__faq-mobile__title">{t('Consulta le FAQ')}</h3>
              <p className="contatti-template__faq-mobile__description">
                {t(
                  'Trova le risposte alle domande più frequenti poste dalla community di Giunti Scuola'
                )}
              </p>
              <Button
                variant="secondary"
                href="/faq/faq-giuntiscuola"
                className="contatti-template__faq__item"
                label={t('Leggi le domande frequenti')}
              />
            </div>
            <div className="contatti-template__form-box">
              <h1 className="contatti-template__form-box__title">{t('Invia una richiesta')}</h1>
              <p className="contatti-template__form-box__description">
                {t('Compila i campi e inviaci la tua richiesta.')}
              </p>
              <Formik
                innerRef={formRef}
                initialValues={{
                  ...initialValues,
                }}
                validationSchema={schemaContatti}
                onSubmit={values => {
                  const cleanedData = { ...values, ruolo: values.ruolo.label }
                  postData(cleanedData)
                }}
                enableReinitialize
              >
                {({
                  values,
                  touched,
                  errors,
                  isValid,
                  isSubmitting,
                  dirty,
                  handleBlur,
                  handleChange,
                  setFieldValue,
                  handleSubmit,
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      size="invisible"
                      sitekey={RECAPTCHA_KEY}
                      // onChange={onChange}
                    />
                    <FormLayout>
                      <FormField
                        label={`${t('Sono un')}*`}
                        status={getFormFieldStatus({ touched, errors }, 'ruolo')}
                        errorMessage={errors?.ruolo}
                        layout="half"
                      >
                        <FormSelect
                          value={values?.ruolo}
                          options={optionsRuolo}
                          onBlur={handleBlur('ruolo')}
                          onChange={selectedOption => setFieldValue('ruolo', selectedOption, true)}
                          status={getFormFieldStatus({ touched, errors }, 'ruolo')}
                        />
                      </FormField>
                      <FormField
                        label={`${t('Email')}*`}
                        status={getFormFieldStatus({ touched, errors }, 'email')}
                        errorMessage={errors?.email}
                        layout="half"
                      >
                        <FormInput
                          value={values?.email}
                          onBlur={handleBlur('email')}
                          onChange={handleChange('email')}
                          status={getFormFieldStatus({ touched, errors }, 'email')}
                        />
                      </FormField>
                    </FormLayout>
                    <FormLayout>
                      <FormField
                        label={`${t('Nome')}*`}
                        status={getFormFieldStatus({ touched, errors }, 'nome')}
                        errorMessage={errors?.nome}
                        layout="half"
                      >
                        <FormInput
                          value={values?.nome}
                          onBlur={handleBlur('nome')}
                          onChange={handleChange('nome')}
                          status={getFormFieldStatus({ touched, errors }, 'nome')}
                        />
                      </FormField>
                      <FormField
                        label={`${t('Cognome')}*`}
                        status={getFormFieldStatus({ touched, errors }, 'cognome')}
                        errorMessage={errors?.cognome}
                        layout="half"
                      >
                        <FormInput
                          value={values?.cognome}
                          onBlur={handleBlur('cognome')}
                          onChange={handleChange('cognome')}
                          status={getFormFieldStatus({ touched, errors }, 'cognome')}
                        />
                      </FormField>
                    </FormLayout>
                    <FormLayout>
                      <FormField
                        label={t('Il tuo messaggio*')}
                        status={getFormFieldStatus({ touched, errors }, 'richiesta')}
                        errorMessage={errors?.richiesta}
                        layout="full"
                      >
                        <FormTextarea
                          placeholder={t('Scrivi qui la tua richiesta')}
                          value={values.richiesta}
                          onBlur={handleBlur('richiesta')}
                          onChange={handleChange('richiesta')}
                          status={getFormFieldStatus({ touched, errors }, 'richiesta')}
                        />
                      </FormField>
                    </FormLayout>
                    <FormField>
                      <FormCheckbox
                        id={'privacy'}
                        label={
                          <>
                            {t('Ho letto e compreso l’')}
                            <a href="/privacy-policy" className="w-form__privacy-link">
                              informativa privacy
                            </a>{' '}
                            {t('e accetto integralmente i Termini d’uso.')}
                          </>
                        }
                        name={'privacy'}
                        value={values.privacy}
                        checked={values.privacy}
                        onChange={handleChange}
                      />
                    </FormField>
                    <FormField>
                      <FormCheckbox
                        id={'commerciale'}
                        label={t(
                          "Accetto il trattamento dei dati, per la durata prevista dall'informativa, per restare aggiornato su novità e promozioni dalle aziende del Gruppo Giunti."
                        )}
                        name={'commerciale'}
                        value={values.commerciale}
                        checked={values.commerciale}
                        onChange={handleChange}
                      />
                    </FormField>
                    <FormField>
                      <FormCheckbox
                        id={'profilazione'}
                        label={t(
                          'Accetto la profilazione dei dati per ricevere un servizio maggiormente personalizzato.'
                        )}
                        name={'profilazione'}
                        value={values.profilazione}
                        checked={values.profilazione}
                        onChange={handleChange}
                      />
                    </FormField>
                    <div className="contatti-template__form-box__submit">
                      <input
                        type="submit"
                        value="Invia la richiesta"
                        disabled={!(isValid && dirty) || isSubmitting}
                        className=" button button--primary"
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
          <div className="contatti-template__container__right">
            <div className="contatti-template__faq">
              <h3 className="contatti-template__faq__title">{t('Consulta le FAQ')}</h3>
              <p className="contatti-template__faq__description">
                {t(
                  'Trova le risposte alle domande più frequenti poste dalla community di Giunti Scuola'
                )}
              </p>
              <Button
                variant="secondary"
                colorVariant="white"
                href="/faq/faq-giuntiscuola"
                className="contatti-template__faq__item"
                label={t('Leggi le domande frequenti')}
              />
            </div>
            <div className="contatti-template__contatti">
              <h3 className="contatti-template__contatti__title">
                {t('Hai bisogno di contattarci?')}
              </h3>
              <div className="contatti-template__contatti__box">
                <p className="contatti-template__contatti__box__title">
                  {t('Assistenza e informazioni Giunti Scuola')}
                </p>
                <p className="contatti-template__contatti__box__content">
                  {t('Scrivi a ')}
                  <a
                    href="mailto:sos.scuola@giunti.it"
                    className="contatti-template__contatti__box__content__mailto"
                  >
                    sos.scuola@giunti.it
                  </a>
                </p>
                <p className="contatti-template__contatti__box__content">
                  {t('Chiama al numero ')}
                  <b>
                    <a href="tel:0555062424">055 5062424</a>
                  </b>
                  <br />
                  <span>{t('dal lunedi al venerdì 9.00 - 18.00')}</span>
                </p>
              </div>
              <div className="contatti-template__contatti__box">
                <p className="contatti-template__contatti__box__title">
                  {t('Assistenza DBookeasy e digitale')}
                </p>
                <p className="contatti-template__contatti__box__content">
                  {t('Scrivi a ')}
                  <a
                    href="mailto:giuntiscuoladigitale@giunti.it"
                    className="contatti-template__contatti__box__content__mailto"
                  >
                    giuntiscuoladigitale@giunti.it
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </WContainer>
    </main>
  )
}

export default ContattiTemplate
